module.exports = __webpack_public_path__ + "static/img/bigbang-logo02.ed6bb8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bigbang-logo02.svg
// module id = H0Ad
// module chunks = 1